import styled from 'styled-components';
import { Button } from 'antd';

export const Divider = styled.hr`
    width: 100%;
    height: 1px;
    border: none;
    margin: 3rem 0;
    background-color: #e4e9f0;
`;

export const TitleHeaderArea = styled.div`
    width: 100%;
    height: 100%;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const TitleHeader = styled.span`
    font-weight: 600;
    font-size: 16px;
    text-wrap: balance;
`;

export const TitleTable = styled.h1`
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 20px;
`;

export const ContainerTables = styled.div`
    display: flex;
    flex-wrap: no-wrap;
    overflow-x: auto;
    padding-bottom: 10px;

    .pointed {
        cursor: pointer;
    }

    .ant-table-tbody > tr.ant-table-row-selected.deleted.edited > td {
        background: rgba(255, 78, 78, 0.35) !important;
    }

    .ant-table-tbody > tr.ant-table-row-selected.edited > td {
        background: rgb(75, 124, 243, 0.7) !important;
    }
    .hidden-checkbox .ant-table-cell > .ant-checkbox-wrapper {
        display: none;
    }
`;

export const TitleResult = styled.h1`
    font-weight: 400;
    font-size: 16px;
`;

export const SelectedBadge = styled.span`
    font-size: 12px;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 4px;
    color: ${({ theme }) => theme.colors.colorPrimaryHover};
    background: ${({ theme }) =>
        `color-mix(in srgb, ${theme.colors.colorPrimaryHover} 12%, transparent)`};
`;

export const StyledRow = styled.div`
    display: flex;
    margin-bottom: 2rem;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .btn-group {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 2rem;

        &:first-child {
            margin-right: 2rem;
        }
    }

    @media screen and (max-width: 600px) {
        flex-direction: column;
        justify-content: start;
        align-items: stretch;

        .btn-group {
            margin-top: 2rem;
            width: 100%;
            grid-template-columns: 1fr;
            gap: 0.75rem;
        }

        .btn-group .ant-btn {
            width: 100%;
        }
    }
`;

export const ResultRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
    margin: 16px 0;

    h1 {
        margin: 0;
    }
`;

export const AddProductButton = styled(Button)`
    display: flex;
    align-items: center;
    gap: 9px;
    height: 38px;
    font-weight: 500;
    font-size: 14px;
`;
